export const KNOWN_INSIGHT_TYPES = [
  "hero-market-context",
  "shift-volume",
  "morning-mvp",
  "evening-all-star",
  "night-shift-legend",
  "all-hours-champion",
  "urgent-champion",
  "planning-ahead",
  "total-earnings",
  "total-earnings-lifetime",
  "agent-req-diversity",
  "distance-and-commute",
  "top-workplaces",
  "team-and-connections",
  "community-reviews",
  "summary",
] as const;
export type KnownInsightType = (typeof KNOWN_INSIGHT_TYPES)[number];

export type InsightWrapperVariant = KnownInsightType | "start" | "loading";
